import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M3.333 4.833a1.5 1.5 0 0 1 1.5-1.5h4.476a1.5 1.5 0 0 1 1.061.44l5.857 5.857a1.5 1.5 0 0 1 0 2.121l-4.476 4.476a1.5 1.5 0 0 1-2.121 0L3.773 10.37a1.5 1.5 0 0 1-.44-1.061z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.5",
      d: "M7.083 7.083h.008"
    }, null, -1)
  ]))]))
}
export default { render: render }